import { Component, DestroyRef, Input, inject } from '@angular/core';
import { GbrChildInput, GbrPersonType } from '@coin/shared/gbr/util';
import moment from 'moment';
import { GbrRequestDialogComponent } from '../../gbr-request-dialog.component';
import { SimpleGbrInputType } from '../../inputs/simple-gbr-input/simple-gbr-input.component';

@Component({
  selector: 'coin-siemens-energy-input-overview',
  templateUrl: './input-overview.component.html',
  styleUrls: ['./input-overview.component.scss'],
  standalone: false
})
export class InputOverviewComponent {
  private destroyRef = inject(DestroyRef);

  @Input() values: GbrRequestDialogComponent['travelPersons'];
  @Input() stepIndex = 0;

  public simpleInputTypes = SimpleGbrInputType;
  public personTypes = GbrPersonType;

  private isMinor(child?: GbrChildInput): boolean {
    return child && moment.utc().diff(child?.birthday, 'years') < 18;
  }

  private isAdult(child?: GbrChildInput): boolean {
    return child && moment.utc().diff(child?.birthday, 'years') >= 18;
  }

  get minorChildren(): GbrChildInput[] {
    return this.values.controls.children.value.filter(this.isMinor);
  }

  get adultChildren(): GbrChildInput[] {
    return this.values.controls.children.value.filter(this.isAdult);
  }
}
